import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="21" height="23" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M1.728.815a1 1 0 00-1.456 1.37l8.855 9.412-8.855 9.411a1 1 0 001.456 1.37l8.772-9.322 8.772 9.323a1 1 0 001.456-1.37l-8.855-9.412 8.855-9.412a1 1 0 10-1.456-1.37L10.5 10.137 1.728.816z" fill="#007B8B" /></svg>);